import moment from 'moment/moment';
import { HttpClient } from '@/shared/lib/http-client';

export const fetchProductsStatistics = async (filters = {}) => {
  const START_DATE_FILTER_INDEX = 0;
  const END_DATE_FILTER_INDEX = 1;

  const getPeriodFilter = (index) => Array.isArray(filters.period) && filters.period.length === 2
  && moment(filters.period[index]).isValid() ? moment(filters.period[index]).format('YYYY-MM-DD') : null;

  const response = await HttpClient.get('/statistic/products', {
    user_id: filters?.partner || null,
    product_type: filters?.product || null,
    start_date: getPeriodFilter(START_DATE_FILTER_INDEX),
    end_date: getPeriodFilter(END_DATE_FILTER_INDEX),
  });

  return response.data?.data;
};
